import { Injectable } from '@angular/core';

import { Am5DateValueXYChart } from '../../../Common/Charts/models/Am5DateValueXYChart/am5-date-value-x-y-chart.model';
import { Am5ResponsiveRule } from '../../../Common/Charts/models/responsive-rule.model';
import { ReportBlockTypeEnum } from '../enums/report-block-type.enum';
import { ChartSizeHelper } from '../../../Common/Charts/helpers/chart-size.helper';
import { ChartSpecificTypesEnum } from '../enums/chart-specific-types.enum';


@Injectable()
export class Am5ChartResponsiveRulesService {

    getResponsiveRules(type: ReportBlockTypeEnum, _chartSpecificType: ChartSpecificTypesEnum): Am5ResponsiveRule[] {
        let rules: Am5ResponsiveRule[] = [];
        let smallChartWidth, smallChartHeight, largeChartWidth, largeChartHeight;
        switch (type) {
            case ReportBlockTypeEnum.SENTIMENT_TREND:
            case ReportBlockTypeEnum.COVERAGE_IMPACT_TREND:
            case ReportBlockTypeEnum.COVERAGE_OVER_TIME:
            case ReportBlockTypeEnum.COVERAGE_OVER_TIME_COMPARISON:
                smallChartWidth = ChartSizeHelper.getChartGridWidth(3);
                smallChartHeight = ChartSizeHelper.getChartGridHeight(2);
                largeChartWidth = ChartSizeHelper.getChartGridWidth(4);
                largeChartHeight = ChartSizeHelper.getChartGridHeight(3);
                rules = [
                    {
                        relevant: (width: number, height: number) => width <= smallChartWidth || height <= smallChartHeight,
                        applying: function() {
                            const chart = this as unknown as Am5DateValueXYChart;
                            const scrollbar = chart.amchart.get('scrollbarX');
                            if (scrollbar) {
                                scrollbar.startGrip.set('scale', 0.7);
                                scrollbar.endGrip.set('scale', 0.7);
                            }
                            chart.dateAxis?.get('renderer').labels.template.set('fontSize', 12);
                            chart.valueAxes.forEach(axis => axis.get('renderer').labels.template.set('fontSize', 12));
                            if (chart.legend) {
                                if (!chart.config.disableLegendScroll) {
                                    chart.legend.set('maxHeight', chart.config.isStacked ? 70 : 54);
                                }
                                chart.legend.labels.template.set('fontSize', '0.75rem');
                                chart.legend.itemContainers.template.setAll({
                                    scale: 0.9,
                                    paddingTop: 0,
                                    paddingBottom: 0
                                });
                            }
                        },
                        removing: function() {
                            const chart = this as unknown as Am5DateValueXYChart;
                            const scrollbar = chart.amchart.get('scrollbarX');
                            if (scrollbar) {
                                scrollbar.startGrip.set('scale', 0.8);
                                scrollbar.endGrip.set('scale', 0.8);
                            }
                            chart.dateAxis?.get('renderer').labels.template.set('fontSize', 13);
                            chart.valueAxes.forEach(axis => axis.get('renderer').labels.template.set('fontSize', 14));
                            if (chart.legend) {
                                chart.legend.set('maxHeight', 500);
                                chart.legend.labels.template.set('fontSize', '0.875rem');
                                chart.legend.itemContainers.template.setAll({
                                    scale: 1,
                                    paddingTop: 1,
                                    paddingBottom: 1
                                });
                            }
                        }
                    },
                    {
                        relevant: (width: number, height: number) => width > largeChartWidth && height > largeChartHeight,
                        applying: function() {
                            const chart = this as unknown as Am5DateValueXYChart;
                            if (chart.legend) {
                                chart.legend.markers.template.set('scale', 1);
                            }
                        },
                        removing: function() {
                            const chart = this as unknown as Am5DateValueXYChart;
                            if (chart.legend) {
                                chart.legend.markers.template.set('scale', 0.8);
                            }
                        }
                    }
                ];
                break;
        }

        return rules;
    }

    private isBarChart(chartSpecificType: ChartSpecificTypesEnum): boolean {
        return chartSpecificType === ChartSpecificTypesEnum.BAR ||
            chartSpecificType === ChartSpecificTypesEnum.MULTI_STACKED_BAR;
    }
}
